import React, { useState, useEffect } from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { gql } from 'apollo-boost';
import { useMutation } from '@apollo/react-hooks';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useHistory } from 'react-router';
import { getQuoteBuilderURL } from '../../helpers/common';

const UPDATE_QUOTE = gql`
  mutation updateQuote($QuoteInput: QuoteInput) {
    updateQuote(input: $QuoteInput) {
      QuoteId
      QuoteTypeId1
      QuoteTypeId2
      Description
      WorkflowStep
    }
  }
`;

const REVERT_QUOTE = gql`
  mutation revertQuote($QuoteInput: QuoteInput) {
    revertQuote(input: $QuoteInput) {
      QuoteId
      Status
      WorkflowStep
    }
  }
`;

const DUPLICATE_QUOTE = gql`
  mutation duplicateQuote($QuoteInput: QuoteInput) {
    duplicateQuote(input: $QuoteInput) {
      QuoteId
      QuoteTypeId1
      QuoteTypeId2
      Description
      WorkflowStep
    }
  }
`;

const ActionDropdown = ({ quote, refetch }) => {
  const history = useHistory();
  const [dropdownOpen, setOpen] = useState(false);
  const [showRevertConfirm, setShowRevertConfirm] = useState(false);
  const toggle = () => setOpen(!dropdownOpen);
  const quoteURL = getQuoteBuilderURL(quote.WorkflowStep, quote.QuoteId);
  const [updateQuote, { data: updatedQuoteData }] = useMutation(UPDATE_QUOTE);
  const [revertQuote] = useMutation(REVERT_QUOTE);
  const [duplicateQuote, { data: duplicatedQuoteData }] = useMutation(DUPLICATE_QUOTE);

  const updateQuoteStatus = (quoteId, status) => {
    updateQuote({ variables: { QuoteInput: { QuoteId: quoteId, Status: status } } });
  };

  const revertQuoteStatus = (quoteId) => {
    return revertQuote({ variables: { QuoteInput: { QuoteId: quoteId } } });
  };

  useEffect(() => {
    if (updatedQuoteData || duplicatedQuoteData) refetch();
  }, [updatedQuoteData, duplicatedQuoteData, refetch]);

  return (
    <React.Fragment>
      {showRevertConfirm && (
        <SweetAlert
          warning
          title="Confirm"
          onConfirm={() => {
            revertQuoteStatus(quote.QuoteId).then(() => refetch());
            setShowRevertConfirm(false);
          }}
          onCancel={() => setShowRevertConfirm(false)}
          showCancel
          confirmBtnText="Revert"
          cancelBtnText="Cancel"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="secondary"
        >
          Revert "{quote.Description}" to In Progress?
        </SweetAlert>
      )}
      <ButtonDropdown isOpen={dropdownOpen} toggle={toggle} onClick={(e) => e.stopPropagation()}>
        <DropdownToggle size="sm" className="list-action-menu">
          <i className="fas fa-ellipsis-h"></i>
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={() => history.push(quoteURL)}>
            View Quote
          </DropdownItem>
          {quote.Status !== 'accepted' && quote.Status !== 'voided' && (
            <DropdownItem onClick={() => updateQuoteStatus(quote.QuoteId, 'voided')}>
              Void Quote
            </DropdownItem>
          )}
          {quote.Status === 'initial_acceptance' && (
            <DropdownItem onClick={() => setShowRevertConfirm(true)}>
              Revert Acceptance
            </DropdownItem>
          )}
          <DropdownItem
            onClick={() => {
              duplicateQuote({ variables: { QuoteInput: { QuoteId: quote.QuoteId } } })
                .then(({ data: { duplicateQuote: newQuote } }) => {
                  if (newQuote) history.push(`/quote-setup/${newQuote.QuoteId}`);
                });
            }}
          >
            Duplicate
          </DropdownItem>
          {quote.Status === 'in_progress' && (
            <DropdownItem onClick={() => updateQuoteStatus(quote.QuoteId, 'archived')}>
              Archive
            </DropdownItem>
          )}
          {quote.Status === 'archived' && (
            <DropdownItem onClick={() => updateQuoteStatus(quote.QuoteId, 'in_progress')}>
              Restore
            </DropdownItem>
          )}
        </DropdownMenu>
      </ButtonDropdown>
    </React.Fragment>
  );
};

export default ActionDropdown;
